import axios from "axios";
import useSWR from "swr";
import { upsertReusableBowlsToCart } from "../Helpers/reusable-bowls-utils";
import CheckoutSession from "../pages/Checkout/CheckoutSession";
import { API_URL, fetcher } from "./apiConfig";

export const updateCartMutation = async (cart) => {
    const { uid: cartUid } = cart;

    if (!cartUid) {
        return;
    }

    const applyReusableBowls =
        CheckoutSession.isSet() && CheckoutSession.isReusableToggled();

    if (applyReusableBowls) {
        cart.items = upsertReusableBowlsToCart(cart);
    }

    try {
        const response = await axios.put(`${API_URL}/cart/${cartUid}`, cart);

        if (response.status !== 200) {
            throw new Error(response);
        }

        return { ok: true, cart: response.data };
    } catch (err) {
        return { ok: false, msg: err.response.data.message };
    }
};

export const checkoutCartMutation = async (cart) => {
    const cartUid = cart.uid;

    try {
        const response = await axios.post(
            `${API_URL}/cart/${cartUid}/checkout`,
            cart
        );

        const wasOrderCompletedSuccesfully = Boolean(
            response.data?.redirect_to
        );

        return {
            ok: wasOrderCompletedSuccesfully,
            redirect_to: response.data?.redirect_to,
            msg: "Success",
            cart: wasOrderCompletedSuccesfully ? cart : response.data,
        };
    } catch (err) {
        return {
            ok: false,
            msg: err?.response?.data?.message || "Error with checkout request",
            redirect_to: undefined,
            cart: err?.response.data.data || cart,
        };
    }
};

export const createCartMutation = async (cart) => {
    try {
        const response = await axios.post(`${API_URL}/cart`, cart);
        if (response.status !== 200) {
            return { ok: false };
        }

        return { ok: true, cart: response.data };
    } catch (err) {
        return { ok: false, msg: err.response.data.message };
    }
};

export const patchGroupCart = async ({
    uid,
    status,
    owner_uid,
    timeslot = undefined,
}) => {
    try {
        let body = {
            status,
        };

        if (timeslot) {
            body = { ...body, ...timeslot };
        }

        const response = await axios.patch(
            `${API_URL}/cart/group/${uid}?owner-uid=${owner_uid}`,
            body
        );
        return { ok: true, data: response.data };
    } catch (err) {
        return { ok: false, msg: err.response.data.message };
    }
};

export const useGroupCart = ({
    uid,
    enabled,
    owner_uid,
    updateCartCallback = () => null,
}) => {
    let url = `${reactConfig.url}/cart/group/${uid}`;

    if (owner_uid) {
        url = `${url}?owner-uid=${owner_uid}`;
    }

    const { data, error } = useSWR(enabled ? url : undefined, fetcher, {
        onSuccess: (data) => {
            updateCartCallback(data);
        },
        keepPreviousData: true,
    });

    const isLoading = !error && !data;
    const isError = error;

    return {
        data,
        isError,
        isLoading,
    };
};

export const commitGroupParticipant = async ({
    groupUid,
    participantUid,
    items,
    customer_id,
}) => {
    const url = `${reactConfig.url}/cart/group/${groupUid}/participant/${participantUid}/commit`;

    try {
        const body = {
            cart_items: items.map((item) => {
                let itemData = {
                    uid: item.uid,
                    add: item.add,
                    comment: item.comment,
                    owner_uid: participantUid,
                    owner_name: item.owner_name,
                    product_id: item.product_id,
                    quantity: item.quantity,
                    remove: item.remove,
                };

                if (item?.hash) {
                    itemData = { ...itemData, customer_id, hash: item.hash };
                }

                return itemData;
            }),
        };
        const response = await axios.post(url, body, { withCredentials: true });
        return { ok: true, data: response.data };
    } catch (error) {
        return { ok: true, data: null };
    }
};

export const joinGroupAsParticipant = async ({
    groupUid,
    participantUid,
    participantName,
}) => {
    const url = `${reactConfig.url}/cart/group/${groupUid}/participant/${participantUid}/join`;
    try {
        const body = {
            participant_name: participantName,
        };

        const response = await axios.post(url, body, { withCredentials: true });
        return { ok: true, data: response.data };
    } catch (error) {
        return { ok: false, data: null };
    }
};

export const leaveGroupAsParticipant = async ({ groupUid, participantUid }) => {
    const url = `${reactConfig.url}/cart/group/${groupUid}/participant/${participantUid}/leave`;
    try {
        const response = await axios.post(url, {}, { withCredentials: true });
        return { ok: true, data: response.data };
    } catch (error) {
        return { ok: false, data: null };
    }
};
